import { IReportInfo } from "../../../../api/types/reports/IReportInfo";
import { IReportParams } from "../../../../api/types/reports/IReportParams";

export const mapReportPramsToReportInfo = (
  info: IReportInfo,
  params: IReportParams,
): IReportInfo => {
  return { ...info, ...params } as IReportInfo;
};
